import Joi from 'joi-browser'
import i18n from '../i18n'

export function validateLogin(request) {
    const schema = {
        usernameOrEmail: Joi.string()
            .min(3)
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.minRequired', { min: 3 })
                }
            }),
        password: Joi.string()
            .min(5)
            .required()
            .max(255)
            .error(() => {
                return {
                    message: i18n.t('errors.minRequired', { min: 5 })
                }
            })
    }
    return Joi.validate(request, schema, { abortEarly: false })
}

export function validateSignup(request) {
    const schema = {
        name: Joi.string()
            .min(3)
            .required()
            .max(30)
            .error(() => {
                return {
                    message: i18n.t('errors.minRequired', { min: 3 })
                }
            }),
        email: Joi.string()
            .min(5)
            .email()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.email')
                }
            }),
        password: Joi.string()
            .min(5)
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.minRequired', { min: 5 })
                }
            }),
        gender: Joi.string()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.required')
                }
            }),
        maritalStatus: Joi.string()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.required')
                }
            }),
        kids: Joi.string()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.required')
                }
            }),
        purpose: Joi.string()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.required')
                }
            }),
        age: Joi.string()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.required')
                }
            }),
        country: Joi.string()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.required')
                }
            }),
        describeYourself: Joi.string()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.required')
                }
            }),
        describeOthers: Joi.string()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.required')
                }
            })
    }
    return Joi.validate(request, schema, { abortEarly: false })
}

export function validateMessage(request) {
    const schema = {
        title: Joi.string()
            .required()
            .max(50)
            .error(() => {
                return {
                    message: i18n.t('errors.maxRequired', { max: 50 })
                }
            }),
        message: Joi.string()
            .max(512)
            .error(() => {
                return {
                    message: i18n.t('errors.maxRequired', { max: 512 })
                }
            })
    }
    return Joi.validate(request, schema, { abortEarly: false })
}

export function validatePasswordChange(request) {
    const schema = {
        oldPassword: Joi.string()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.required')
                }
            }),
        newPassword: Joi.string()
            .min(5)
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.minRequired', { min: 5 })
                }
            }),
        passwordConfirmation: Joi.string()
            .valid(Joi.ref('newPassword'))
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.passwordMatch')
                }
            })
    }
    return Joi.validate(request, schema, { abortEarly: false })
}

export function validatePasswordReset(request) {
    const schema = {
        newPassword: Joi.string()
            .min(5)
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.minRequired', { min: 5 })
                }
            }),
        passwordConfirmation: Joi.string()
            .valid(Joi.ref('newPassword'))
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.passwordMatch')
                }
            })
    }
    return Joi.validate(request, schema, { abortEarly: true })
}

export function validateOptions(request) {
    const schema = {
        maritalStatus: Joi.required().error(() => {
            return {
                message: i18n.t('errors.required')
            }
        }),
        kids: Joi.required().error(() => {
            return {
                message: i18n.t('errors.required')
            }
        }),
        purpose: Joi.required().error(() => {
            return {
                message: i18n.t('errors.required')
            }
        }),
        age: Joi.required().error(() => {
            return {
                message: i18n.t('errors.required')
            }
        }),
        country: Joi.required().error(() => {
            return {
                message: i18n.t('errors.required')
            }
        }),
        describeYourself: Joi.string()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.required')
                }
            }),
        describeOthers: Joi.string()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.required')
                }
            })
    }
    return Joi.validate(request, schema, { abortEarly: false })
}

export function validateContactSupport(request) {
    const schema = {
        name: Joi.string()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.required')
                }
            }),
        email: Joi.string()
            .min(5)
            .email()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.email')
                }
            }),
        message: Joi.string()
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.required')
                }
            })
    }
    return Joi.validate(request, schema, { abortEarly: false })
}

export function validateUsernameOrEmail(request) {
    const schema = {
        usernameOrEmail: Joi.string()
            .min(3)
            .required()
            .error(() => {
                return {
                    message: i18n.t('errors.minRequired', { min: 3 })
                }
            })
    }
    return Joi.validate(request, schema, { abortEarly: false })
}
